export const documentTypeConstants = {
  NATIONAL_ID: 0,
  PASSPORT: 1,
  FAMILY_CARD: 2,
  KITE_SURFING_CERTIFICATE: 3,
  WIND_SURFING_CERTIFICATE: 4,
  WING_FOILING_CERTIFICATE: 5,
  SAILING_CERTIFICATE: 6,
  PROFILE_PICTURE: 7,
  CENTER_LOGO: 8,
  NAFES: 9,
  OPERATIONAL: 10,
  SAFETY: 11,
};
